import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    payments: [],
    payment: {},
    pagination: {},
    new_payment: {},
    validate_form: {},
  },
  actions,
  mutations,
  getters,
};
